import React from "react";
import LoginComponent from "../../landing/login-component";

export default function Login() {
  return <LoginComponent mode="login" />;
}
